import { render, staticRenderFns } from "./mrp.vue?vue&type=template&id=6bfa077f"
import script from "./mrp.vue?vue&type=script&lang=js"
export * from "./mrp.vue?vue&type=script&lang=js"
import style0 from "./mrp.vue?vue&type=style&index=0&id=6bfa077f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports